import React from 'react'

const StatWidget = ({ icon, value, label, style = {} }) => (
  <div
    style={{
      background: '#fff',
      borderRadius: 16,
      boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
      padding: '18px 24px',
      minWidth: 180,
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      ...style
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          background: '#f5f6fa',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icon}
      </div>
      <div>
        <div style={{ fontWeight: 700, fontSize: 22, color: '#222', lineHeight: 1 }}>{value}</div>
        <div style={{ fontSize: 14, color: '#888', marginTop: 2 }}>{label}</div>
      </div>
    </div>
  </div>
)

export default StatWidget


